import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { getMonthName } from '../../../core/helper/month';
import { IDataContext } from '../../../core/component/list/component.interface';
import { LocalDate } from '../../../core/model/local-date';

@Component({
    selector: 'app-invoice-period',
    templateUrl: './invoice-period.component.html',
    styleUrls: ['./invoice-period.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoicePeriodComponent implements OnChanges, OnInit, IDataContext {
  constructor() {}

  @Input() dataContext: any;

  month: string;
  samePeriod: boolean;
  year: number;

  private _updateState() {
    let from = LocalDate.fromDate(this.dataContext.periodFrom);
    let to = LocalDate.fromDate(this.dataContext.periodTo);
    if (from.month == to.month) {
      this.month = getMonthName(from.month);
      this.year = from.year;
      this.samePeriod = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataContext']) {
      this._updateState();
    }
  }

  ngOnInit() {
    if (this.dataContext) {
      this._updateState();
    }
  }
}
